import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@blueprintjs/core'
import { Card, OutlineType } from 'client/components/Card/Card'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import DisplaySettings from 'images/svg/display_settings.svg'
import HiddenCosts from 'images/svg/hidden_costs.svg'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const MorBlock: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.PricingPage)

  return (
    <ResponsiveBlock size="medium" type="primary">
      <div className="relative flex w-full flex-col gap-8 py-8 lg:gap-20 lg:py-30">
        <div className="flex w-full flex-col gap-8 lg:absolute lg:bottom-full lg:translate-y-1/2 lg:flex-row lg:gap-3">
          <Card className="w-full py-12 lg:w-4/12" outlineType={OutlineType.Shadow}>
            <div className="flex w-full flex-col gap-4 px-8">
              <div className="flex h-8 w-8">
                <img src={DisplaySettings} className="w-full" />
              </div>
              <Text tagName="span" className="font-secondary-regular---22pt lg:font-secondary-regular---30pt">
                {t('mor_block.title')}
              </Text>
              <Text tagName="span" className="font-primary-regular---15pt">
                {t('mor_block.caption')}
              </Text>
            </div>
          </Card>
          <div className="flex flex-1">
            <div className="flex w-full">
              <img src={HiddenCosts} className="w-full object-contain" />
            </div>
          </div>
        </div>
        <div className="hidden w-full pt-20 lg:flex xl:pt-40" />
      </div>
    </ResponsiveBlock>
  )
}

export { MorBlock }
